import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import V3ParticipatingCinemas from "@components/V3/V3ParticipatingCinemas";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const CinemasPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;

    return (
        <VersionedLayout>
            <Helmet>
                <title>{`${brand} | ${whiteLabel?.brand_title}`}</title>
                <meta name="keywords" content={`${brand} | ${whiteLabel?.brand_title}`} />
                <link rel="canonical" href={`${window.location.protocol}//${window.location.host}`} />
            </Helmet>
            <V3ParticipatingCinemas />
        </VersionedLayout>

    );
};

export default CinemasPage;
